/** Formatação pt-BR. Datas de calendário chegam como ISO (UTC meia-noite). */

export function dateOnly(v: string | null | undefined): string {
  if (!v) return "";
  return v.slice(0, 10);
}

export function fmtDate(v: string | null | undefined): string {
  if (!v) return "—";
  const d = v.slice(0, 10).split("-");
  if (d.length !== 3) return v;
  return `${d[2]}/${d[1]}/${d[0]}`;
}

export function fmtDateTime(v: string | null | undefined): string {
  if (!v) return "—";
  return new Date(v).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

export function fmtMoney(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === "") return "—";
  return Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function fmtPercent(v: string | number | null | undefined): string {
  if (v === null || v === undefined) return "—";
  return `${(Number(v) * 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;
}

export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function addDaysIso(iso: string, n: number): string {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export function monthIso(d = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/** "1.234,56" ou "1234.56" → "1234.56" */
export function parseMoneyInput(v: string): string {
  const s = v.trim().replace(/\s|R\$/g, "");
  if (!s) return "";
  if (s.includes(",")) return s.replace(/\./g, "").replace(",", ".");
  return s;
}

/** "20" ou "20%" ou "0,2" → "0.2" */
export function parsePercentInput(v: string): string {
  const s = v.trim().replace("%", "").replace(",", ".");
  if (!s) return "";
  const n = Number(s);
  if (!Number.isFinite(n)) return s;
  return String(n > 1 ? n / 100 : n);
}

export function isOverdue(iso: string | null | undefined): boolean {
  return !!iso && iso.slice(0, 10) < todayIso();
}

export const STATE_LABEL: Record<string, string> = {
  aguardando_atribuicao: "Na fila",
  atribuida: "A fazer",
  em_andamento: "Fazendo",
  aguardando_dependencia: "Aguardando etapa anterior",
  em_revisao: "Em revisão",
  concluida: "Concluída",
  cancelada: "Cancelada",
};

export const COMM_STATUS_LABEL: Record<string, string> = {
  nao_analisada: "Não analisada",
  conferir: "Aviso do tribunal (conferir)",
  ciencia: "Ciência",
  com_obrigacao: "Com obrigação",
  descartada: "Descartada",
};

/** Tipo da movimentação (mesma lista do classificador da API: shared/mail-parse.ts). */
export const MOVE_KIND_LABEL: Record<string, string> = {
  decisao: "Decisão", despacho: "Despacho", sentenca: "Sentença", acordao: "Acórdão", intimacao: "Intimação/Citação", prazo: "Prazo",
  audiencia: "Audiência", juntada: "Juntada", conclusao: "Conclusão", distribuicao: "Distribuição", arquivamento: "Arquivamento/Baixa/Extinção",
  transito: "Trânsito em julgado", outros: "Outros",
};
export const MOVE_KIND_TONE: Record<string, "bad" | "warn" | "info" | "neutral"> = {
  decisao: "warn", sentenca: "bad", acordao: "bad", intimacao: "bad", prazo: "bad", audiencia: "warn", transito: "warn", despacho: "info",
};

export const SOURCE_LABEL: Record<string, string> = {
  djen: "DJEN", datajud: "DataJud (CNJ)", tribunal: "Tribunal", push: "Push (e-mail do tribunal)", manual: "Manual",
};

export const NATURE_LABEL: Record<string, string> = {
  judicial: "Judicial", administrativa: "Administrativa", extrajudicial: "Extrajudicial",
};

export const ACTION_LABEL: Record<string, string> = {
  "pessoa.ver": "Ver pessoas", "pessoa.editar": "Editar pessoas",
  "caso.ver": "Ver casos", "caso.editar": "Editar casos",
  "processo.ver": "Ver processos", "processo.editar": "Editar processos", "processo.revisar": "Revisar situação processual", "processo.excluir": "Excluir processo",
  "atividade.ver": "Ver atividades", "atividade.editar": "Editar atividades", "atividade.atribuir": "Atribuir atividades", "atividade.concluir": "Concluir atividades", "atividade.prazo_fatal.alterar": "Alterar prazo fatal",
  "comunicacao.ver": "Ver comunicações", "comunicacao.triar": "Analisar comunicações", "comunicacao.verificar": "Verificar obrigações", "comunicacao.conferir_manual": "Conferência manual",
  "financeiro.ver": "Ver financeiro", "financeiro.lancar": "Lançar no financeiro", "financeiro.fechar_periodo": "Fechar/reabrir mês", "financeiro.aprovar_distribuicao": "Aprovar distribuições", "financeiro.gerente": "Gerente financeiro (caixa, fluxo, relatórios)", "financeiro.gerencial": "Financeiro gerencial",
  "documento.ver": "Ver documentos", "documento.enviar": "Enviar documentos",
  "config.gerenciar": "Configurações do escritório", "permissao.gerenciar": "Usuários e permissões", "auditoria.ver": "Ver auditoria", "bi.ver": "Ver indicadores", "bi.equipe": "Indicadores da equipe", "meta.gerenciar": "Gerenciar metas", "sociedade.ver": "Ver Sociedade", "sociedade.gerenciar": "Editar Sociedade", "ia.assistente": "Usar o Assistente de IA",
};
